// extracted by mini-css-extract-plugin
export default {"standard-layout":"StandardLayout_standard-layout__tcdxI"};